import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { UploadPortfolioComponent } from './upload-portfolio.component';
import { MatIconModule } from '@angular/material/icon';
import { MatLegacyInputModule as MatInputModule } from '@angular/material/legacy-input';
import { MatLegacyButtonModule as MatButtonModule } from '@angular/material/legacy-button';
import { MatLegacyDialogModule as MatDialogModule } from '@angular/material/legacy-dialog';



@NgModule({
  declarations: [UploadPortfolioComponent],
  imports: [
    CommonModule,
    MatIconModule,
    MatInputModule,
    MatButtonModule,
    MatDialogModule,
  ],
  exports: [UploadPortfolioComponent]
})
export class UploadPortfolioModule { }
